import { Card } from 'react-bootstrap';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { Icon } from '../../shared/components';

interface KpiCardProps {
  title: string;
  value: number;
  icon: IconDefinition;
  variant: 'success' | 'warning' | 'danger' | 'primary' | 'info';
  onClick?: () => void;
}

export function KpiCard({ title, value, icon, variant, onClick }: KpiCardProps) {
  const colorMap = {
    success: { bg: 'var(--color-success-light)', text: 'var(--color-success-dark)', icon: '#4CAF50' },
    warning: { bg: '#FFF8E1', text: '#F57C00', icon: '#FFC107' },
    danger: { bg: '#FFEBEE', text: '#C62828', icon: '#F44336' },
    primary: { bg: '#E3F2FD', text: '#1565C0', icon: '#2196F3' },
    info: { bg: '#E0F7FA', text: '#00838F', icon: '#00BCD4' }
  };

  const colors = colorMap[variant];

  return (
    <Card
      className="kpi-card shadow-sm h-100"
      style={{
        cursor: onClick ? 'pointer' : 'default',
        transition: 'all 0.2s ease',
        backgroundColor: colors.bg,
        border: `2px solid ${colors.text}`
      }}
      onClick={onClick}
      role={onClick ? 'button' : undefined}
      tabIndex={onClick ? 0 : undefined}
      onKeyDown={(e) => {
        if (onClick && (e.key === 'Enter' || e.key === ' ')) {
          e.preventDefault();
          onClick();
        }
      }}
    >
      <Card.Body className="p-3">
        <div className="d-flex justify-content-between align-items-center mb-2">
          <div
            className="kpi-value fw-bold"
            style={{
              fontSize: 'clamp(1.75rem, 3.5vw, 2.25rem)',
              color: colors.text,
              lineHeight: 1
            }}
          >
            {value.toLocaleString()}
          </div>
          <div
            className="kpi-icon-container rounded-circle d-flex align-items-center justify-content-center"
            style={{
              width: '40px',
              height: '40px',
              backgroundColor: 'rgba(255, 255, 255, 0.9)',
              color: colors.icon,
              fontSize: '20px',
              flexShrink: 0
            }}
          >
            <Icon icon={icon} />
          </div>
        </div>
        <div
          className="kpi-label text-uppercase fw-semibold"
          style={{
            fontSize: '0.875rem',
            color: colors.text,
            letterSpacing: '0.5px',
            opacity: 0.8
          }}
        >
          {title}
        </div>
      </Card.Body>
    </Card>
  );
}
